export default __webpack_public_path__ + "static/media/037-stay home.fd86c6ed.svg";